import React from 'react';
import Control from './Control/Control';

const Controls = ({ filters, activeFilter }) => {
  const isActive = (filter) => {
    if (activeFilter && activeFilter.id === filter.id) {
      return true;
    }
    return false;
  };

  return (
    <div className="text-center section__smaller program-grid--tabs">
      <ul className="tabs">
        {filters.map((filter) => (
          <Control
            key={`${filter.id}`}
            isActive={isActive(filter)}
            filter={filter}
          />
        ))}
      </ul>
    </div>
  );
};

export default Controls;
